import { render } from "./PttMessage.vue?vue&type=template&id=b4bc8040"
import script from "./PttMessage.vue?vue&type=script&lang=js"
export * from "./PttMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__